import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import styled, { css, keyframes } from 'styled-components'

export const Container = styled.div`
    display: flex;
    padding: 0px 20px 40px 20px;
`

export const ImageContainer = styled.div`
    position: relative;
    width: 16rem;
    height: 12rem;
`

export const ImageComponent = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: filter 0.3s ease;

    ${ImageContainer}:hover & {
        filter: blur(2px);
    }
`

export const IconButtons = styled.div<{ isVisible: boolean }>`
    display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
    position: absolute;
    flex-direction: column;
    top: 5px;
    right: 5px;
    gap: 5px;
    padding: 5px;
    opacity: 0.9;
    height: 100%;
    ${({ isVisible }) =>
        isVisible &&
        css`
            animation: ${slideInFromRight} 0.3s ease-out forwards;
        `}
`

export const IconButton = styled(Button)`
    background-color: #ba9d31;
    border: none;
    color: #fff;
    font-size: 1rem;
    font-weight: 600;
    padding: 10px 15px;
    border-radius: 6px;

    &:focus,
    &:hover:enabled {
        background-color: #8b761b;
        border-color: #ba9d31;
        box-shadow: 0 0 3px #ba9d31;
    }
`

export const IconButtonDelete = styled(IconButton)`
    align-self: flex-end;
    margin-top: auto;
    background-color: #cc3333;
    margin-bottom: 0.5rem;

    &:focus,
    &:hover:enabled {
        background-color: #8b0000;
        border-color: #cc3333;
        box-shadow: 0 0 3px #cc3333;
    }
`

export const StyledCard = styled(Card)`
    width: 16rem;
    justify-self: flex-start;
    align-self: flex-start;
    transition: border 0.3s ease;

    .p-card-body {
        display: flex;
        justify-items: center;
        margin: auto;
    }

    .p-card-body .p-card-title {
        margin: auto;
        font-family: 'Helvetica Neue';
        font-size: 16px;
        font-weight: 500;
    }
`

const slideInFromRight = keyframes`
    0% {
        transform: translateX(15%);
        opacity: 0;
    }
    100% {
        transform: translateX(0);
        opacity: 1;
    }
`
